import { useNavigate, useSearchParams } from "@solidjs/router";
import { Text, View, hexColor } from "@lightningtv/solid";
import packageJson from "../../../package.json";
import { Show, createEffect, onMount, createSignal } from "solid-js";
import Subscriptions from "./components/Subscriptions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Account from "./components/Acoount";
import Language from "./components/Language";
import { Button } from "@lightningtv/solid-ui";
import { changeLanguage, fontFamily, isRTL, locale, menuX, t } from "../../translations/configuration";
import styles from "../../styles";
import SetPin from "../../components/SetPin";
import DnsSettings from "./components/dnsSelector";
import {
  deviceModel,
  tizenVersion,
  screenResolution,
  screenSize,
  deviceDUID,
  networkType,
  manufacturer,
  deviceYear,
  storageInfo,
  deviceMacAddress,
  privacyModeInfo,
  getProxyData
} from "../../../state";
import { ChangePin } from "./functions/ChangePin";
import Header from "../../components/Header";
import StreamExtension from "./components/StreamExtension";
import StorageAndData from "./components/StorageAndData";

const UserInfo = () => {
  let accountRef, subscriptionsRef, languageRef, changePINRef, policyRef;
  let enLanguage, itLang, deLang, frLang, esLang, saLang, grLang, trLang, cnLang;
  let deviceInfoRef;
  let streamExtRef, streamExtTsRef, streamExtM3u8Ref: any;
  let storageAndDataRef: any;
  let storageAndDataFavChannelsRef: any;
  let storageAndDataFavMoviesRef: any;
  let storageAndDataFavSeriesRef: any;
  let storageAndDataContinueWatchingMoviesRef: any;
  let storageAndDataContinueWatchingSeriesRef: any;
  let storageAndDataClearAllRef: any;

  let internetRef;
  let killSwitchMenuRef;
  let killSwitchModalCancelRef;
  let killSwitchModalOkRef;
  let killSwitchToggleRef;

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [accountFocus, setAccountFocus] = createSignal(false);
  const [subscriptionFocus, setSubscriptionFocus] = createSignal(false);
  const [languageFocus, setLanguageFocus] = createSignal(false);
  const [changePin, setChangePin] = createSignal(false);
  const [privacyPolicyFocus, setPrivacyPolicyFocus] = createSignal(false);
  const [day, setDay] = createSignal("");
  const [dateTime, setDateTime] = createSignal("");
  const [deviceInfoFocus, setDeviceInfoFocus] = createSignal(false);
  const [playlistExpDate, setPlaylistExpDate] = createSignal("");
  const [streamExtFocus, setStreamExtFocus] = createSignal(false);
  const [internetFocus, setInternetFocus] = createSignal(false);
  const [killSwitchEnabled, setKillSwitchEnabled] = createSignal(false);
  const [storageAndDataFocus, setStorageAndDataFocus] = createSignal(false); // 👈 NEW
  const [dnsType, setDnsType] = createSignal("system");
  const [customDns, setCustomDns] = createSignal({
    primary1: "8", primary2: "8", primary3: "8", primary4: "8",
    secondary1: "8", secondary2: "8", secondary3: "4", secondary4: "4"
  });

  const [killSwitchFocus, setKillSwitchFocus] = createSignal(false);
  const [showKillSwitchModal, setShowKillSwitchModal] = createSignal(false);
  const [pendingKillSwitchState, setPendingKillSwitchState] = createSignal(false);

  let dnsInput1Ref, dnsInput2Ref, dnsInput3Ref, dnsInput4Ref;
  let dnsInput5Ref, dnsInput6Ref, dnsInput7Ref, dnsInput8Ref;
  let systemDnsRef: any;

  const [currentFieldIndex, setCurrentFieldIndex] = createSignal(0);
  const fieldNames = ['primary1', 'primary2', 'primary3', 'primary4', 'secondary1', 'secondary2', 'secondary3', 'secondary4'];
  const fieldRefs = () => [dnsInput1Ref, dnsInput2Ref, dnsInput3Ref, dnsInput4Ref, dnsInput5Ref, dnsInput6Ref, dnsInput7Ref, dnsInput8Ref];

  const contentX = () => isRTL() ? 500 : 600;
  const separatorX = () => isRTL() ? 1420 : 540;

  const [editingField, setEditingField] = createSignal(null);
  const [inputValue, setInputValue] = createSignal("");

  // Helper: reset all focus signals
  const resetAllFocus = () => {
    setAccountFocus(false);
    setSubscriptionFocus(false);
    setLanguageFocus(false);
    setPrivacyPolicyFocus(false);
    setChangePin(false);
    setInternetFocus(false);
    setDeviceInfoFocus(false);
    setKillSwitchFocus(false);
    setStreamExtFocus(false);
    setStorageAndDataFocus(false); // 👈 NEW
  };

  const isGoogleDns = () => {
    const dns = customDns();
    return dnsType() === "custom" &&
      dns.primary1 === "8" && dns.primary2 === "8" &&
      dns.primary3 === "8" && dns.primary4 === "8" &&
      dns.secondary1 === "8" && dns.secondary2 === "8" &&
      dns.secondary3 === "4" && dns.secondary4 === "4";
  };

  const isCloudflareDns = () => {
    const dns = customDns();
    return dnsType() === "custom" &&
      dns.primary1 === "1" && dns.primary2 === "1" &&
      dns.primary3 === "1" && dns.primary4 === "1" &&
      dns.secondary1 === "1" && dns.secondary2 === "0" &&
      dns.secondary3 === "0" && dns.secondary4 === "1";
  };

  const isQuad9Dns = () => {
    const dns = customDns();
    return dnsType() === "custom" &&
      dns.primary1 === "9" && dns.primary2 === "9" &&
      dns.primary3 === "9" && dns.primary4 === "9" &&
      dns.secondary1 === "149" && dns.secondary2 === "112" &&
      dns.secondary3 === "112" && dns.secondary4 === "112";
  };

  const isCustomDnsSelected = () => {
    return dnsType() === "custom" && !isGoogleDns() && !isCloudflareDns() && !isQuad9Dns();
  };

  const saveDnsSettingsEnhanced = () => {
    const dnsSettings = { type: dnsType(), customDns: customDns() };
    localStorage.setItem("dnsSettings", JSON.stringify(dnsSettings));
    saveDnsSettings();
  };

  const startEditing = (field) => {
    setEditingField(field);
    setInputValue(customDns()[field]);
  };

  const saveField = () => {
    if (editingField()) {
      const newValue = inputValue();
      if (newValue && parseInt(newValue) >= 0 && parseInt(newValue) <= 255) {
        setCustomDns(prev => ({ ...prev, [editingField()]: newValue }));
        setTimeout(() => saveDnsSettingsEnhanced(), 50);
      }
      setEditingField(null);
      setInputValue("");
    }
  };

  const cancelEditing = () => {
    setEditingField(null);
    setInputValue("");
  };

  const handleDigitInput = (digit) => {
    if (editingField()) {
      const currentValue = inputValue();
      const newValue = currentValue + digit;
      if (parseInt(newValue) <= 255) setInputValue(newValue);
    }
  };

  const handleBackspace = () => {
    if (editingField()) setInputValue(prev => prev.slice(0, -1));
  };

  const handleKeypadDigit = (digit) => {
    const currentField = fieldNames[currentFieldIndex()];
    const newValue = digit;
    if (parseInt(newValue) <= 255) {
      setCustomDns(prev => ({ ...prev, [currentField]: newValue }));
      const nextIndex = currentFieldIndex() + 1;
      if (nextIndex < fieldNames.length) {
        setCurrentFieldIndex(nextIndex);
        setTimeout(() => fieldRefs()[nextIndex]?.setFocus?.(), 50);
      }
      setTimeout(() => saveDnsSettingsEnhanced(), 100);
    }
  };

  const handleKeypadDelete = () => {
    const currentField = fieldNames[currentFieldIndex()];
    setCustomDns(prev => ({ ...prev, [currentField]: '0' }));
    const prevIndex = currentFieldIndex() - 1;
    if (prevIndex >= 0) {
      setCurrentFieldIndex(prevIndex);
      setTimeout(() => fieldRefs()[prevIndex]?.setFocus?.(), 50);
    }
    setTimeout(() => saveDnsSettingsEnhanced(), 100);
  };

  const changePinKeyboardRef: any = {};
  const setPinKeyboardRef: any = {};

  const saveDnsSettings = () => {
    const dnsSettings = { type: dnsType(), customDns: customDns() };
    localStorage.setItem("dnsSettings", JSON.stringify(dnsSettings));
  };

  const loadDnsSettings = () => {
    const savedSettings = localStorage.getItem("dnsSettings");
    if (savedSettings) {
      const parsed = JSON.parse(savedSettings);
      setDnsType(parsed.type || "system");
      if (parsed.customDns) setCustomDns(parsed.customDns);
    }
  };

  onMount(() => { getProxyData(); });

  onMount(() => {
    const paramValue = searchParams.fromPIN;
    if (paramValue === 'true') {
      changePINRef?.setFocus();
    } else {
      accountRef?.setFocus();
      setAccountFocus(true);
    }
  });

  onMount(() => {
    const now = new Date();
    const currentLocale = locale();
    const savedKillSwitch = localStorage.getItem("killSwitch");
    setKillSwitchEnabled(savedKillSwitch === "enabled");
    const exp_date = localStorage.getItem('@playlist_exp_date');
    setPlaylistExpDate(exp_date || "");
    loadDnsSettings();

    const dayNamesByLocale = {
      en: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      sa: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
      it: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
      de: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
      es: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      fr: ["Dimanche", "Lunedi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"]
    };

    const dayNames = dayNamesByLocale[currentLocale] || dayNamesByLocale.en;
    const dayName = dayNames[now.getDay()];
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    setDay(dayName);
    setDateTime(`${day}/${month}/${year} | ${hours}:${minutes}`);
  });

  const handlePinSet = () => {
    const paramValue = searchParams.fromPIN;
    if (paramValue === 'true') {
      navigate(-1);
    } else {
      changePINRef?.setFocus();
    }
  };

  return (
    <View
      color={hexColor("#0d0f14")}
      onEscape={() => navigate(-1)}
      width={3000}
    >
      <Header screen={t("settings")} />

      <View y={100}>
        {/* Account */}
        <View
          x={menuX()}
          y={100}
          onDown={() => subscriptionsRef?.setFocus()}
          onFocus={() => { resetAllFocus(); setAccountFocus(true); }}
        >
          <Text ref={el => { accountRef = el; }} x={isRTL() ? 0 : 30} y={18}
            width={470}
            contain="width"
            textAlign={isRTL() ? "right" : "left"}
            style={{ fontFamily: fontFamily(), fontSize: 35, color: hexColor("#ffffff"), focus: { color: hexColor("#326dcf") } }}>
            {t("account")}
          </Text>
        </View>

        {/* Subscriptions */}
        <View
          x={menuX()}
          y={170}
          onDown={() => policyRef?.setFocus()}
          onUp={() => accountRef?.setFocus()}
          onFocus={() => { resetAllFocus(); setSubscriptionFocus(true); }}
        >
          <Text ref={el => { subscriptionsRef = el; }} x={isRTL() ? 0 : 30} y={18}
            width={470}
            contain="width"
            textAlign={isRTL() ? "right" : "left"}
            style={{ fontFamily: fontFamily(), fontSize: 35, color: hexColor("#ffffff"), focus: { color: hexColor("#326dcf") } }}>
            {t("subscriptions")}
          </Text>
        </View>

        {/* Privacy Policy */}
        <View
          x={menuX()}
          y={245}
          onUp={() => subscriptionsRef?.setFocus()}
          onDown={() => languageRef?.setFocus()}
          onFocus={() => { resetAllFocus(); setPrivacyPolicyFocus(true); }}
        >
          <Text ref={el => { policyRef = el; }} x={isRTL() ? 0 : 30} y={18}
            width={470}
            contain="width"
            textAlign={isRTL() ? "right" : "left"}
            style={{ fontFamily: fontFamily(), fontSize: 35, color: hexColor("#ffffff"), focus: { color: hexColor("#326dcf") } }}>
            {t("privacyPilicy")}
          </Text>
        </View>

        {/* Language */}
        <View
          x={menuX()}
          y={315}
          onUp={() => policyRef?.setFocus()}
          onRight={() => isRTL() ? null : enLanguage?.setFocus()}
          onLeft={() => isRTL() ? saLang?.setFocus() : null}
          onDown={() => changePINRef?.setFocus()}
          onFocus={() => { resetAllFocus(); setLanguageFocus(true); }}
        >
          <Text ref={el => { languageRef = el; }} x={isRTL() ? 0 : 30} y={18}
            width={470}
            contain="width"
            textAlign={isRTL() ? "right" : "left"}
            style={{ fontFamily: fontFamily(), fontSize: 35, color: hexColor("#ffffff"), focus: { color: hexColor("#326dcf") } }}>
            {t("languge")}
          </Text>
        </View>

        {/* Change PIN */}
        <View
          x={menuX()}
          y={390}
          onUp={() => languageRef?.setFocus()}
          onDown={() => killSwitchMenuRef?.setFocus()}
          onRight={() => {
            if (!isRTL()) {
              localStorage.getItem('userPin') === null
                ? setPinKeyboardRef.setFocus?.()
                : changePinKeyboardRef.setFocus?.();
            }
          }}
          onLeft={() => {
            if (isRTL()) {
              localStorage.getItem('userPin') === null
                ? setPinKeyboardRef.setFocus?.()
                : changePinKeyboardRef.setFocus?.();
            }
          }}
          onFocus={() => { resetAllFocus(); setChangePin(true); }}
        >
          <Text ref={el => { changePINRef = el; }} x={isRTL() ? 0 : 30} y={18}
            width={470}
            contain="width"
            textAlign={isRTL() ? "right" : "left"}
            style={{ fontFamily: fontFamily(), fontSize: 35, color: hexColor("#ffffff"), focus: { color: hexColor("#326dcf") } }}>
            {t("change_pin")}
          </Text>
        </View>

        {/* Kill Switch */}
        <View
          x={menuX()}
          y={465}
          onUp={() => changePINRef?.setFocus()}
          onDown={() => streamExtRef?.setFocus()}
          onRight={() => isRTL() ? null : killSwitchToggleRef?.setFocus()}
          onLeft={() => isRTL() ? killSwitchToggleRef?.setFocus() : null}
          onFocus={() => { resetAllFocus(); setKillSwitchFocus(true); }}
        >
          <Text ref={el => { killSwitchMenuRef = el; }} x={isRTL() ? 0 : 30} y={18}
            width={470}
            contain="width"
            textAlign={isRTL() ? "right" : "left"}
            style={{ fontFamily: fontFamily(), fontSize: 35, color: hexColor("#ffffff"), focus: { color: hexColor("#326dcf") } }}>
            {t("kill_switch")}
          </Text>
        </View>

        {/* Stream Extension */}
        <View
          x={menuX()}
          y={540}
          onUp={() => killSwitchMenuRef?.setFocus()}
          onDown={() => storageAndDataRef?.setFocus()}
          onRight={() => { if (!isRTL()) streamExtTsRef?.setFocus(); }}
          onLeft={() => { if (isRTL()) streamExtTsRef?.setFocus(); }}
          onFocus={() => { resetAllFocus(); setStreamExtFocus(true); }}
        >
          <Text ref={el => { streamExtRef = el; }} x={isRTL() ? 0 : 30} y={18}
            width={470}
            contain="width"
            textAlign={isRTL() ? "right" : "left"}
            style={{ fontFamily: fontFamily(), fontSize: 35, color: hexColor("#ffffff"), focus: { color: hexColor("#326dcf") } }}>
            {t("stream_extension")}
          </Text>
        </View>

        {/* ── Storage And Data ── 👇 NEW MENU ITEM */}
        <View
          x={menuX()}
          y={615}
          onUp={() => streamExtRef?.setFocus()}
          onRight={() => { if (!isRTL()) storageAndDataFavChannelsRef?.setFocus(); }}
          onLeft={() => { if (isRTL()) storageAndDataFavChannelsRef?.setFocus(); }}
          onDown={() => deviceInfoRef?.setFocus()}
          onFocus={() => { resetAllFocus(); setStorageAndDataFocus(true); }}
        >
          <Text ref={el => { storageAndDataRef = el; }} x={isRTL() ? 0 : 30} y={18}
            width={470}
            contain="width"
            textAlign={isRTL() ? "right" : "left"}
            style={{ fontFamily: fontFamily(), fontSize: 35, color: hexColor("#ffffff"), focus: { color: hexColor("#326dcf") } }}>
            {t("storage_and_data")}
          </Text>
        </View>

        {/* Device Information */}
        <View
          x={menuX()}
          y={690}
          onUp={() => storageAndDataRef?.setFocus()}
          onRight={() => deviceInfoRef?.setFocus()}
          onFocus={() => { resetAllFocus(); setDeviceInfoFocus(true); }}
        >
          <Text ref={el => { deviceInfoRef = el; }} x={isRTL() ? 0 : 30} y={18}
            width={470}
            contain="width"
            textAlign={isRTL() ? "right" : "left"}
            style={{ fontFamily: fontFamily(), fontSize: 35, color: hexColor("#ffffff"), focus: { color: hexColor("#326dcf") } }}>
            {t("device_info")}
          </Text>
        </View>

        {/* Separator line */}
        <View
          x={separatorX()}
          y={120}
          style={{
            borderLeftWidth: 0.5,
            height: 530, // 👈 slightly taller to cover new menu item
            width: 1,
            color: hexColor("#b4b1b162"),
          }}
        />

        {/* Content panels */}
        <Show when={accountFocus()}>
          <Account x={contentX()} />
        </Show>
        <Show when={subscriptionFocus()}>
          <Subscriptions x={contentX()} />
        </Show>
        <Show when={privacyPolicyFocus()}>
          <PrivacyPolicy x={contentX()} />
        </Show>
        <Show when={changePin()}>
          <Show when={localStorage.getItem('userPin') === null} fallback={
            <ChangePin onPinSet={handlePinSet} keyboardRef={changePinKeyboardRef} changePINRef={changePINRef} />}
          >
            <SetPin
              onPinSet={handlePinSet}
              showSkip={false}
              showBackground={false}
              x={600}
              y={50}
              onBackLeft={() => changePINRef.setFocus?.()}
              keyboardRef={setPinKeyboardRef}
              isForFast={searchParams.fromPIN}
            />
          </Show>
        </Show>

        <Show when={streamExtFocus()}>
          <StreamExtension
            x={contentX()}
            tsRef={(el) => { streamExtTsRef = el; }}
            m3u8Ref={(el) => { streamExtM3u8Ref = el; }}
            onLeftFromOption={() => isRTL() ? null : streamExtRef?.setFocus()}
            onRightFromOption={() => isRTL() ? storageAndDataRef?.setFocus() : null}
          />
        </Show>

        <Show when={internetFocus()}>
          <View x={550} y={80} height={900} width={1300} clipping>
            <DnsSettings
              onBack={() => internetRef?.setFocus?.()}
              onSave={(settings) => console.log("DNS settings saved:", settings)}
              setSystemDnsRef={(ref) => (systemDnsRef = ref)}
            />
          </View>
        </Show>

        {/* Kill Switch Modal */}
        <Show when={showKillSwitchModal()}>
          <View width={1920} height={1080} positionAbsolute={0} style={{ zIndex: 2000 }}>
            <View x={460} y={240} width={1000} height={400} color={hexColor("#ffffff")} borderRadius={25}>
              <View x={50} y={40}>
                <Text x={0} y={10}
                  width={900} contain="width" textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 32, color: hexColor("#000000"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                  {pendingKillSwitchState() ? t("enableKillSwitch") : t("disableKillSwitch")}
                </Text>
              </View>
              <View x={50} y={120}>
                <Text x={0} y={0}
                  width={900} contain="width" textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 24, color: hexColor("#326dcf"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                  {t("extra_privacy_protection")}
                </Text>
                <View x={0} y={50}>
                  <Text x={0} y={0}
                    width={900} contain="width" textAlign={isRTL() ? "right" : "left"}
                    style={{ fontSize: 20, color: hexColor("#000000"), fontFamily: fontFamily() }}>
                    {pendingKillSwitchState() ? t("whenEnabled") : t("withOrWithoutPM")}
                  </Text>
                  <Text x={0} y={40}
                    width={900} contain="width" textAlign={isRTL() ? "right" : "left"}
                    style={{ fontSize: 18, color: hexColor("#666666"), fontFamily: fontFamily() }}>
                    {pendingKillSwitchState() ? t("pmOn") : t("killSwitchDescription")}
                  </Text>
                  <Text x={0} y={70}
                    width={900} contain="width" textAlign={isRTL() ? "right" : "left"}
                    style={{ fontSize: 18, color: hexColor("#666666"), fontFamily: fontFamily() }}>
                    {pendingKillSwitchState() ? t("pmOff") : t("reenable")}
                  </Text>
                </View>
              </View>
              <View x={300} y={290}>
                <View
                  ref={(el) => { killSwitchModalCancelRef = el; }}
                  x={0} y={0}
                  style={{ borderRadius: 20, color: hexColor("#C1C3C1"), focus: { color: hexColor("#326dcf") }, height: 60, width: 150 }}
                  onRight={() => { if (!isRTL()) killSwitchModalOkRef?.setFocus(); }}
                  onLeft={() => { if (isRTL()) killSwitchModalOkRef?.setFocus(); }}
                  onEnter={() => { setShowKillSwitchModal(false); killSwitchToggleRef?.setFocus(); }}
                >
                  <Text x={0} y={20}
                    width={150} contain="width" textAlign="center"
                    style={{ fontSize: 24, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                    {t("cancel")}
                  </Text>
                </View>
                <View
                  ref={(el) => { killSwitchModalOkRef = el; }}
                  x={200} y={0}
                  style={{
                    borderRadius: 20,
                    color: hexColor("#808080"),
                    focus: { color: pendingKillSwitchState() ? hexColor("#00cc00") : hexColor("#ff4444") },
                    transition: { scale: { duration: 250, easing: "ease-in-out" } },
                    height: 60, width: 150,
                  }}
                  onLeft={() => { if (!isRTL()) killSwitchModalCancelRef?.setFocus(); }}
                  onRight={() => { if (isRTL()) killSwitchModalCancelRef?.setFocus(); }}
                  onEnter={() => {
                    const newState = pendingKillSwitchState();
                    setKillSwitchEnabled(newState);
                    localStorage.setItem("killSwitch", newState ? "enabled" : "disabled");
                    setShowKillSwitchModal(false);
                    killSwitchToggleRef?.setFocus();
                  }}
                >
                  <Text x={0} y={20}
                    width={150} contain="width" textAlign="center"
                    style={{ fontSize: 24, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                    {pendingKillSwitchState() ? t("enable") : t("disable")}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </Show>

        <Show when={killSwitchFocus()}>
          <View x={isRTL() ? 500 : 600} y={80} height={2000} width={920} clipping>
            <Text
              width={880} contain="width" textAlign={isRTL() ? "right" : "left"}
              style={{ fontSize: 32, color: hexColor("#f0f6fc"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
              {t("killSwitch")}
            </Text>
            <Text y={54}
              textAlign={isRTL() ? "right" : "left"}
              style={{ fontSize: 22, color: hexColor("#9ca3af"), fontFamily: fontFamily(), width: 880, contain: "width", lineHeight: 34 }}>
              {t("ipHidden")}
            </Text>
            <Text y={130}
              textAlign={isRTL() ? "right" : "left"}
              style={{ fontSize: 22, color: hexColor("#9ca3af"), fontFamily: fontFamily(), width: 880, contain: "width", lineHeight: 34 }}>
              {t("extraLayer")}
            </Text>

            {/* O bullet — icon mirrors to right in RTL */}
            <View y={210}>
              <Text x={isRTL() ? 856 : 0} style={{ fontSize: 24, color: hexColor("#22c55e"), fontFamily: fontFamily() }}>O</Text>
              <Text x={isRTL() ? 0 : 30}
                textAlign={isRTL() ? "right" : "left"}
                style={{ fontSize: 22, color: hexColor("#d1d5db"), fontFamily: fontFamily(), width: 840, contain: "width" }}>
                {t("ifPmOn")}
              </Text>
            </View>

            {/* X bullet — icon mirrors to right in RTL */}
            <View y={258}>
              <Text x={isRTL() ? 856 : 0} style={{ fontSize: 24, color: hexColor("#ef4444"), fontFamily: fontFamily() }}>X</Text>
              <Text x={isRTL() ? 0 : 30}
                textAlign={isRTL() ? "right" : "left"}
                style={{ fontSize: 22, color: hexColor("#d1d5db"), fontFamily: fontFamily(), width: 840, contain: "width" }}>
                {t("ifPmOff")}
              </Text>
            </View>

            <Text y={316}
              textAlign={isRTL() ? "right" : "left"}
              style={{ fontSize: 22, color: hexColor("#f59e0b"), fontFamily: fontFamily(), width: 880, contain: "width", lineHeight: 34 }}>
              {t("recommended")}
            </Text>
            <Text y={400}
              width={880} contain="width" textAlign={isRTL() ? "right" : "left"}
              style={{ fontSize: 26, color: hexColor("#f0f6fc"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
              {t("current_status")}
            </Text>
            <View
              ref={killSwitchToggleRef}
              x={0} y={442}
              onLeft={() => isRTL() ? null : killSwitchMenuRef?.setFocus()}
              onRight={() => isRTL() ? killSwitchMenuRef?.setFocus() : null}
              onEnter={() => {
                const newState = !killSwitchEnabled();
                setPendingKillSwitchState(newState);
                setShowKillSwitchModal(true);
                setTimeout(() => killSwitchModalCancelRef?.setFocus(), 100);
              }}
              width={380} height={64} borderRadius={10}
              style={{
                color: killSwitchEnabled() ? hexColor("#14532d") : hexColor("#1a1d24"),
                border: { width: 1, color: killSwitchEnabled() ? hexColor("#22c55e") : hexColor("#374151") },
                focus: {
                  color: killSwitchEnabled() ? hexColor("#166534") : hexColor("#1e3a5f"),
                  border: { width: 2, color: killSwitchEnabled() ? hexColor("#22c55e") : hexColor("#2563eb") },
                },
                transition: { color: { duration: 150 } },
              }}
            >
              <Text x={0} y={22}
                width={380} contain="width" textAlign="center"
                style={{ fontSize: 22, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                {killSwitchEnabled() ? t("pressToDisable") : t("pressToEnable")}
              </Text>
            </View>
            <Text y={524}
              textAlign={isRTL() ? "right" : "left"}
              style={{ fontSize: 20, color: hexColor("#6b7280"), fontFamily: fontFamily(), width: 880, contain: "width" }}>
              {t("pressEnter")}
            </Text>
          </View>
        </Show>

        <Show when={deviceInfoFocus()}>
          <View x={contentX()} y={40} height={900} width={920} clipping>
            <Text
              width={880}
              contain="width"
              textAlign={isRTL() ? "right" : "left"}
              style={{ fontSize: 32, color: hexColor("#f0f6fc"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
              {t("device_info")}
            </Text>
            <View y={56}>
              <View y={0}>
                <Text
                  width={880}
                  contain="width"
                  textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 22, color: hexColor("#60a5fa"), fontFamily: fontFamily(), fontWeight: isRTL() ? "normal" : "bold" }}>
                  {(() => { try { const s = JSON.parse(localStorage.getItem('deviceInfo') || '{}'); return s.model || deviceModel() || t("unknown"); } catch { return deviceModel() || t("unknown"); } })()}
                </Text>
                <Text y={32}
                  width={880}
                  contain="width"
                  textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 20, color: hexColor("#d1d5db"), fontFamily: fontFamily() }}>
                  {(() => { try { return manufacturer() || "LG"; } catch { return "LG"; } })()}
                  {" · "}
                  {(() => { try { const s = JSON.parse(localStorage.getItem('deviceInfo') || '{}'); return s.year || deviceYear() || t("unknown"); } catch { return deviceYear() || t("unknown"); } })()}
                </Text>
              </View>
              <View y={80}>
                <Text
                  width={880}
                  contain="width"
                  textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 20, color: hexColor("#60a5fa"), fontFamily: fontFamily(), fontWeight: isRTL() ? "normal" : "bold" }}>
                  {t("display")}
                </Text>
                <Text y={28}
                  width={880}
                  contain="width"
                  textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 20, color: hexColor("#9ca3af"), fontFamily: fontFamily() }}>
                  {(() => { try { const s = JSON.parse(localStorage.getItem('deviceInfo') || '{}'); return s.screenSize || screenSize() || t("unknown"); } catch { return screenSize() || t("unknown"); } })()}
                  {screenResolution() ? ` (${screenResolution()})` : ""}
                </Text>
              </View>
              <View y={152}>
                <Text
                  width={880}
                  contain="width"
                  textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 20, color: hexColor("#60a5fa"), fontFamily: fontFamily(), fontWeight: isRTL() ? "normal" : "bold" }}>
                  {t("storage")}
                </Text>
                <View y={30} x={isRTL() ? 300 : 0} width={580} height={8} borderRadius={4} color={hexColor("#1e2a3a")}>
                  <View width={Math.round(580 * 0.32)} height={8} borderRadius={4} color={hexColor("#2563eb")} />
                </View>
                <Text y={50}
                  width={880}
                  contain="width"
                  textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 20, color: hexColor("#d1d5db"), fontFamily: fontFamily() }}>
                  {storageInfo() || t("unknown")}
                </Text>
              </View>
              <View y={242}>
                <Text
                  width={880}
                  contain="width"
                  textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 20, color: hexColor("#60a5fa"), fontFamily: fontFamily(), fontWeight: isRTL() ? "normal" : "bold" }}>
                  {t("network")}
                </Text>
                {/* Network type row — drop flex, absolute positioning for RTL */}
                <View y={30}>
                  <Text x={isRTL() ? 856 : 0} style={{ fontSize: 20, color: hexColor("#d1d5db"), fontFamily: fontFamily() }}>⌾</Text>
                  <Text x={isRTL() ? 0 : 26} width={840} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#d1d5db"), fontFamily: fontFamily() }}>{networkType() || t("unknown")} {t("connection")}</Text>
                </View>
                {/* MAC address row */}
                <View y={60}>
                  <Text x={isRTL() ? 680 : 0} width={200} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#9ca3af"), fontFamily: fontFamily() }}>{t("macAddress")}</Text>
                  <Text x={isRTL() ? 0 : 160} width={680} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#d1d5db"), fontFamily: fontFamily() }}>
                    {(() => { try { const s = JSON.parse(localStorage.getItem('deviceInfo') || '{}'); return s.device_mac_address || deviceMacAddress() || ""; } catch { return deviceMacAddress() || ""; } })()}
                  </Text>
                </View>
                {/* Device ID row */}
                <View y={90}>
                  <Text x={isRTL() ? 760 : 0} width={120} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#9ca3af"), fontFamily: fontFamily() }}>{t("deviceId")}</Text>
                  <Text x={isRTL() ? 0 : 120} width={760} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#d1d5db"), fontFamily: fontFamily() }}>
                    {(() => { const duid = deviceDUID(); return duid ? `${duid.substring(0, 16)}...` : t("unknown"); })()}
                  </Text>
                </View>
              </View>
              <View y={390}>
                <Text
                  width={880}
                  contain="width"
                  textAlign={isRTL() ? "right" : "left"}
                  style={{ fontSize: 20, color: hexColor("#60a5fa"), fontFamily: fontFamily(), fontWeight: isRTL() ? "normal" : "bold" }}>
                  {t("pmInfo")}
                </Text>
                {/* Status row */}
                <View y={30}>
                  <Text x={isRTL() ? 800 : 0} width={80} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#9ca3af"), fontFamily: fontFamily() }}>{t("status")}</Text>
                  <Text x={isRTL() ? 0 : 80} width={800} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, fontFamily: fontFamily(), fontWeight: isRTL() ? "normal" : "bold", color: privacyModeInfo()?.status === 'OK' ? hexColor("#22c55e") : hexColor("#ef4444") }}>
                    {privacyModeInfo()?.status === 'OK' ? t("statusActive") : t("underMaintance")}
                  </Text>
                </View>
                {/* Version + Date row — flattened, absolute positions for RTL */}
                <View y={62}>
                  <Text x={isRTL() ? 800 : 0} width={80} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#9ca3af"), fontFamily: fontFamily() }}>{t("version")}</Text>
                  <Text x={isRTL() ? 620 : 80} width={180} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#d1d5db"), fontFamily: fontFamily() }}>{privacyModeInfo()?.version || "Unknown"}</Text>
                  <Text x={isRTL() ? 430 : 220} width={190} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#9ca3af"), fontFamily: fontFamily() }}>{t("lastBuildDate")}</Text>
                  <Text x={isRTL() ? 0 : 380} width={430} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#d1d5db"), fontFamily: fontFamily() }}>{privacyModeInfo()?.date || "Unknown"}</Text>
                </View>
              </View>
              {playlistExpDate() !== null && (
                <View y={510}>
                  <Text
                    width={880}
                    contain="width"
                    textAlign={isRTL() ? "right" : "left"}
                    style={{ fontSize: 20, color: hexColor("#60a5fa"), fontFamily: fontFamily(), fontWeight: isRTL() ? "normal" : "bold" }}>
                    {t("playlistInformation")}
                  </Text>
                  {/* Playlist expiry row */}
                  <View y={30}>
                    <Text x={isRTL() ? 640 : 0} width={240} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#9ca3af"), fontFamily: fontFamily() }}>{t("playlistExpDate")}</Text>
                    <Text x={isRTL() ? 0 : 240} width={640} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#60a5fa"), fontFamily: fontFamily() }}>{playlistExpDate() || t("unknown")}</Text>
                  </View>
                </View>
              )}
              {/* Last Updated row */}
              <View y={600}>
                <Text x={isRTL() ? 750 : 0} width={130} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#f59e0b"), fontFamily: fontFamily() }}>{t("lastUpdated")}</Text>
                <Text x={isRTL() ? 0 : 200} width={750} contain="width" textAlign={isRTL() ? "right" : "left"} style={{ fontSize: 20, color: hexColor("#f59e0b"), fontFamily: fontFamily() }}>
                  {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                </Text>
              </View>
            </View>
          </View>
        </Show>

        {/* ── Storage And Data Panel ── 👇 NEW */}
        <Show when={storageAndDataFocus()}>
          <StorageAndData
            x={contentX()}
            y={40}
            onLeftFromOption={() => isRTL() ? null : storageAndDataRef?.setFocus()}
            onRightFromOption={() => isRTL() ? storageAndDataRef?.setFocus() : null}
            favChannelsRef={(el) => { storageAndDataFavChannelsRef = el; }}
            favMoviesRef={(el) => { storageAndDataFavMoviesRef = el; }}
            favSeriesRef={(el) => { storageAndDataFavSeriesRef = el; }}
            continueWatchingMoviesRef={(el) => { storageAndDataContinueWatchingMoviesRef = el; }}
            continueWatchingSeriesRef={(el) => { storageAndDataContinueWatchingSeriesRef = el; }}
            clearAllRef={(el) => { storageAndDataClearAllRef = el; }}
          />
        </Show>

        <Show when={languageFocus()}>
          <Language
            x={isRTL() ? 300 : 600}
            enLanguage={(el) => enLanguage = el}
            languageRef={languageRef}
            itLang={(it) => itLang = it}
            deLang={(de) => deLang = de}
            esLang={(es) => esLang = es}
            frLang={(fr) => frLang = fr}
            saLang={(sa) => saLang = sa}
            grLang={(gr) => grLang = gr}
            cnLang={(cn) => cnLang = cn}
            trLang={(tr) => trLang = tr}
            changeLanguage={changeLanguage}
          />
        </Show>
      </View>

      <View style={styles.line} />
      <View y={930} x={100}>
        <Text fontWeight={isRTL() ? "normal" : "bold"} fontSize={32} style={{ fontFamily: fontFamily() }}>{day()}</Text>
        <Text fontSize={26} color={"#a0a1a3"} y={40}>{dateTime()}</Text>
      </View>

      <Text x={1650} fontSize={27} y={950} color={"#a0a1a3"} style={{ fontFamily: fontFamily() }}>{t("version")} {packageJson.version}</Text>
    </View>
  );
};
export default UserInfo;